import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../stores/root-store-context';
import type { IUser } from '../../model/user';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useProjectUserResult {
    isLoaded: boolean;
    user: IUser | null;
}

export const useProjectUser = (projectId: string, user?: IUser) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState(() => ({
        isLoaded: true,
        user: null
    } as useProjectUserResult));

    useEffect(() => {

        setResult({ isLoaded: false, user: null });

        if (user != null) {
            rootStore.userStore.loadUserForProject(projectId, user.email)
                .then(() => {
                    setResult({ isLoaded: true, user: rootStore.userStore.users[0] });
                })
                .catch(e => {
                        publishNotification({
                            text: `Error Loading user ${user.email} for project ${projectId}`,
                            canClose: true
                        });
                    }
                );
        } else {
            rootStore.userStore.addUser();
            setResult({ isLoaded: true, user: rootStore.userStore.users[0] });
        }
    }, [publishNotification, rootStore.userStore.users, user, projectId]);

    return result;
};
